// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"678":"d23da0d9","787":"efab51f5","941":"2ebadd3c"}[chunkId] + ".chunk.js";
};